"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCredentials = exports.CredentialsContainer = exports.useCredentialRetreival = exports.SESSION_EXPIRED = exports.END_USER_NOT_INITIALIZED = exports.ADMIN_USER_NOT_INITIALIZED = exports.VALIDATED = exports.VALIDATING = exports.NOT_VALIDATED = exports.UNKNOWN = void 0;
const store2_1 = __importDefault(require("store2"));
const qs = __importStar(require("@zipit/ls-core-sdk/dist/querystring"));
const bottleneck_1 = __importDefault(require("bottleneck"));
const constate_1 = __importDefault(require("constate"));
const lodash_1 = require("lodash");
const fast_json_stable_stringify_1 = __importDefault(require("fast-json-stable-stringify"));
const react_1 = require("react");
const ls_core_sdk_1 = require("@zipit/ls-core-sdk");
const api_1 = require("./api");
const auth_1 = require("../auth");
const clearQueryParams_1 = require("../clearQueryParams");
const getInactivityExpiration_1 = require("../getInactivityExpiration");
const superagent = __importStar(require("superagent"));
const uuid_1 = require("uuid");
const USER_NOT_FOUND = 'USER NOT FOUND';
exports.UNKNOWN = 'UNKNOWN';
exports.NOT_VALIDATED = 'NOT_VALIDATED';
exports.VALIDATING = 'VALIDATING';
exports.VALIDATED = 'VALIDATED';
exports.ADMIN_USER_NOT_INITIALIZED = 'ADMIN_USER_NOT_INITIALIZED';
exports.END_USER_NOT_INITIALIZED = 'END_USER_NOT_INITIALIZED';
const getLocationCustomerId = () => {
    let customer;
    let type = 'end-user';
    const { host } = window.location;
    const hosts = host.split('.');
    const subdomain = hosts[0];
    if ((0, lodash_1.includes)(ls_core_sdk_1.PROTECTED_SUBDOMAINS, subdomain)) {
        throw new Error(`${host} is not a valid domain`);
    }
    customer = subdomain;
    if ((0, lodash_1.endsWith)(subdomain, ADMIN_SUFFIX)) {
        type = 'admin';
        customer = subdomain.slice(0, subdomain.length - (ADMIN_SUFFIX.length + 1));
    }
    return { customer, host, subdomain, type };
};
const storeCreds = store2_1.default.get('lsAuthParams');
const sessionData = store2_1.default.get('lsSessionData');
const initialCreds = storeCreds === 'undefined' ? undefined : storeCreds;
const initialSession = sessionData === 'undefined' ? undefined : sessionData;
const ADMIN_SUFFIX = 'admin';
const ORIGIN = window.location.origin;
exports.SESSION_EXPIRED = 'Session Expired';
const useCredentialRetreival = ({ portalOrigins, isPortal }) => {
    const [basePath] = (0, react_1.useState)(ORIGIN);
    const [expired, setExpired] = (0, react_1.useState)(false);
    const [sessionData, setSessionData] = (0, react_1.useState)(initialSession);
    const [credentials, setCredentials] = (0, react_1.useState)(initialCreds);
    const [authBottleneck] = (0, react_1.useState)(new bottleneck_1.default({ maxConcurrent: 1 }));
    const [validationState, setValidationState] = (0, react_1.useState)(store2_1.default.get('lsAuthDriver') ? exports.UNKNOWN : exports.NOT_VALIDATED);
    const prelogin = (0, api_1.usePost)('/v2/api/prelogin');
    const authHeaders = (skipLogouts = false) => authBottleneck.schedule(() => __awaiter(void 0, void 0, void 0, function* () {
        try {
            let tokens = credentials.data;
            if (!skipLogouts && credentials.inactivityExpiration <= Date.now()) {
                throw new Error(exports.SESSION_EXPIRED);
            }
            const client = auth_1.FrontendIdpFactory.createClient(credentials.driver);
            const refresh = yield client.getAuthHeader(tokens, credentials.idp, sessionData === null || sessionData === void 0 ? void 0 : sessionData.sessionId);
            tokens = refresh.data;
            if (refresh.expired) {
                throw new Error(exports.SESSION_EXPIRED);
            }
            else {
                setCredentials(credentials => (Object.assign(Object.assign({}, credentials), { data: tokens, expired: refresh.expired, inactivityExpiration: (0, getInactivityExpiration_1.getNewInactivityExpiration)(credentials.idp) })));
            }
            return refresh.headers;
        }
        catch (e) {
            console.error(e);
            setExpired(true);
            store2_1.default.set('lsRedirect', `${window.location.pathname}${window.location.hash}${window.location.search}`);
            throw new Error(exports.SESSION_EXPIRED);
        }
    }));
    const clearTempLocalStorage = () => {
        const PARAMS_TO_CLEAR = [
            'lsOauthCode',
            'lsOauthState',
            'lsAuthNonce',
            'lsOauthFlow',
            'lsAuthParams',
            'lsAuthDriver',
            'lsAdminCache',
            'lsIdp',
            'lsSessionData',
        ];
        store2_1.default.each(key => {
            if ((0, lodash_1.includes)(PARAMS_TO_CLEAR, key)) {
                store2_1.default.remove(key);
            }
        });
    };
    const loadCredentials = (credentials) => {
        setValidationState(exports.VALIDATING);
        setCredentials(credentials);
        setValidationState(exports.VALIDATED);
    };
    const validateToken = (driver, existing) => __awaiter(void 0, void 0, void 0, function* () {
        setValidationState(exports.VALIDATING);
        try {
            const sessionId = (0, lodash_1.get)(initialSession, 'sessionId', (0, uuid_1.v4)());
            const client = auth_1.FrontendIdpFactory.createClient(driver);
            let params;
            let customer, subdomain;
            if (existing) {
                params = { driver, credentials: existing.creds };
                customer = existing.customer;
                subdomain = existing.subdomain;
            }
            else {
                params = yield client.getCredentials();
                const siteLocation = getLocationCustomerId();
                customer = siteLocation.customer;
                subdomain = siteLocation.subdomain;
            }
            const credentials = yield client.validateParams(params, { basePath, customer, subdomain, sessionId });
            if (!credentials) {
                throw new Error('Could not get valid credentials from driver');
            }
            // validateToken only occurs in the parent frame
            if (!initialSession) {
                setSessionData({ sessionId, documentIds: [] });
            }
            setCredentials(credentials);
            setValidationState(exports.VALIDATED);
            (0, clearQueryParams_1.clearQueryParams)(['code', 'state']);
        }
        catch (e) {
            const error = (0, ls_core_sdk_1.superagentError)(e);
            const { type } = getLocationCustomerId();
            const isAdmin = type === 'admin';
            if ((error === null || error === void 0 ? void 0 : error.message) === USER_NOT_FOUND) {
                return setValidationState(isAdmin ? exports.ADMIN_USER_NOT_INITIALIZED : exports.END_USER_NOT_INITIALIZED);
            }
            // probably we got a 401/403 here, logout, and then send to login page
            clearTempLocalStorage(); // clear out any expired tokens
            if (window.location.pathname.includes('/store') && !e.message.includes('Guest login disallowed')) {
                window.location.href = '/store';
            }
            else {
                redirectToLogin();
            }
            throw e;
        }
    });
    const redirectToLogin = (options) => {
        const { hash } = window.location;
        const isRedirectDisabled = hash.includes('redirect=false');
        if (!isPortal || isRedirectDisabled) {
            return;
        } // child can't do logout, send message to parent
        // go ask the lightspeed backend where to login
        const { customer, type } = getLocationCustomerId();
        // <customer(-admin)?>.localhost:9998 - local development
        // <customer(-admin)?>.zipitportal.com - production
        // <customer(-admin)?>.<stage>.zipiteng.com - dev, stage, test or demo deployments
        prelogin.run({ customerId: customer, type }, { route: options === null || options === void 0 ? void 0 : options.route, signUp: options === null || options === void 0 ? void 0 : options.signUp });
    };
    const logout = (...args_1) => __awaiter(void 0, [...args_1], void 0, function* ({ logout_uri, skipRedirect } = {}) {
        var _a;
        if (!isPortal) {
            return;
        } // child can't do logout, send message to parent
        try {
            yield superagent.post(`${basePath}/v2/api/logout`).set(yield authHeaders(true));
        }
        catch (e) {
            // swallow this if our token is expired already
        }
        store2_1.default.local.remove('intl-language');
        store2_1.default.local.remove('intl-country');
        const idp = ((_a = store2_1.default.get('lsAdminCache')) === null || _a === void 0 ? void 0 : _a.adminIdp) || store2_1.default.get('lsIdp');
        if (idp) {
            clearTempLocalStorage();
            if (skipRedirect) {
                return;
            }
            setValidationState(exports.NOT_VALIDATED);
            setCredentials(undefined);
            const client = auth_1.FrontendIdpFactory.createClient(idp.driver);
            let logoutUrl = client.getLogoutUrl(idp);
            if (logout_uri) {
                const [path, search] = (logoutUrl || '').split('?');
                let query = {};
                if (search) {
                    query = qs.parse(search) || {};
                }
                query.logout_uri = logout_uri;
                logoutUrl = `${path}?${qs.stringify(query)}`;
            }
            window.location.href = logoutUrl;
        }
        // if we couldn't find idp we're already logging out
    });
    (0, react_1.useEffect)(() => {
        store2_1.default.set('lsAuthParams', credentials);
    }, [(0, fast_json_stable_stringify_1.default)(credentials)]);
    (0, react_1.useEffect)(() => {
        store2_1.default.set('lsSessionData', sessionData);
    }, [(0, fast_json_stable_stringify_1.default)(sessionData)]);
    (0, react_1.useEffect)(() => {
        if (prelogin.complete) {
            try {
                const preloginRes = (0, lodash_1.get)(prelogin, 'data');
                if (preloginRes && preloginRes.data && preloginRes.driver) {
                    clearTempLocalStorage();
                    store2_1.default.set('lsAuthDriver', preloginRes.driver);
                    store2_1.default.set('lsIdp', preloginRes);
                    const client = auth_1.FrontendIdpFactory.createClient(preloginRes.driver);
                    let loginUrl = client.getLoginUrl(preloginRes);
                    if (prelogin.meta.signUp) {
                        const idpUrl = new URL(loginUrl);
                        idpUrl.pathname = '/signup';
                        loginUrl = idpUrl.toString();
                    }
                    const redirect = prelogin.meta.route
                        ? `${window.location.pathname}#${prelogin.meta.route}`
                        : `${window.location.pathname}${window.location.hash}${window.location.search}`;
                    store2_1.default.set('lsRedirect', redirect);
                    window.location.href = loginUrl;
                }
            }
            catch (e) {
                throw e;
            }
            if (prelogin.error) {
                throw prelogin.error;
            }
        }
    }, [prelogin.complete]);
    const parentDataLoader = (value) => {
        if (!value.credentials) {
            throw new Error('Page did not get authentication credentials from parent');
        }
        loadCredentials(value.credentials);
    };
    (0, react_1.useEffect)(iFrameListener(genHandleMessage({ parentDataLoader, setExpired, origins: portalOrigins })), [portalOrigins]);
    return {
        credentials,
        setCredentials,
        loadCredentials,
        basePath,
        validationState,
        validateToken,
        redirectToLogin,
        logout,
        authHeaders,
        expired,
        setExpired,
        sessionData,
        setSessionData,
    };
};
exports.useCredentialRetreival = useCredentialRetreival;
const iFrameListener = (handleMessage) => () => {
    window.addEventListener('message', handleMessage, false);
    return () => window.removeEventListener('message', handleMessage);
};
const genHandleMessage = ({ parentDataLoader, setExpired, origins }) => (message) => {
    const { hash } = window.location;
    const isNextApplication = hash.includes('next=true');
    if (!isNextApplication && !(0, lodash_1.includes)(origins, message.origin)) {
        console.warn(`Unknown message from ${message.origin}`);
        return;
    }
    const type = (0, lodash_1.get)(message, 'data.type');
    const value = (0, lodash_1.get)(message, 'data.value');
    switch (type) {
        case 'lsPostChildData':
            parentDataLoader(value);
            break;
        case 'lsCredentialsExpired':
            setExpired(true);
            break;
    }
};
const useCredentialsContainer = (_a) => {
    var { children } = _a, context = __rest(_a, ["children"]);
    return context;
};
_a = (0, constate_1.default)(useCredentialsContainer), exports.CredentialsContainer = _a[0], exports.useCredentials = _a[1];
exports.CredentialsContainer.displayName = 'CredentialsContainer';
//# sourceMappingURL=useCredentials.js.map